import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useToast } from "@/context/ToastContext";
import { useAuth } from "@/context/AuthContext";
import { Loader, Currency, Field } from "@/components/Atoms";
import {
  Shield, Users, Crown, Coins, Settings, Wrench, Ban, ScrollText, Map as MapIcon,
  UserCog, Layers, Gift, PackageOpen, Server, Lock, KeyRound, Flame, Calendar,
  Flag, Sparkles, RefreshCw
} from "lucide-react";



export function Bans() {
  const [bans, setBans] = useState([]);
  useEffect(() => { api.get("/admin/bans").then(({ data }) => setBans(data.bans || [])); }, []);
  return (
    <div className="glass-card p-5 fade-up">
      <h3 className="label mb-3">Bans (read-only)</h3>
      {bans.length === 0 ? <p className="text-[var(--muted)] text-sm">No bans.</p> : (
        <ul className="divide-y divide-white/5">
          {bans.map((b, i) => <li key={i} className="py-2 text-sm">{JSON.stringify(b)}</li>)}
        </ul>
      )}
    </div>
  );
}

// ---------------------------------------------------------------------------
// Server Control — RCON / announce / kick / shutdown / restart / save
// ---------------------------------------------------------------------------
